import React, { useState } from "react";
import {
  Typography,
  Box,
  TextField,
} from "@mui/material";
import { CommonDialog } from "../Components/CommonQuickAdd";
import { addRelation } from "../api/services/employee.service";
import { useSnackbar } from "notistack";

const AddRelation = ({ open, onClose, token, onSuccess }) => {
  const [actionLoading, setActionLoading] = useState(false);

  const handleSave = async () => {
    setActionLoading(true);
    try {
      const payload = {
        Name: formData.Name,
        Description: formData.Description?.trim() || null,
      };

      const response = await addRelation(payload, token);

      if (response?.StatusCode === 200) {
        await onSuccess(); // ⏳ wait for dropdown refresh
        onClose(); // ❌ close popup AFTER refresh
      }
    } catch (error) {
      // console.error("Add Relation Error:", error);
    } finally {
      setActionLoading(false);
    }
  };



  const [formData, setFormData] = useState({
    Name: "",
    Description: "",
  });
  const { enqueueSnackbar } = useSnackbar();
  return (
    <CommonDialog
      open={open}
      onClose={onClose}
      title="Add New Relation"
      loading={actionLoading}
      onSave={handleSave}
    >
      <Box>
        <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
          <Typography sx={{ width: 180, fontSize: "11px" }}>
            Add Relation<span style={{ color: "red" }}>*</span>
          </Typography>
          <TextField
            size="small"
            fullWidth
            value={formData.Name}
            onChange={(e) => {
              if (/^[a-zA-Z0-9\s]*$/.test(e.target.value)) {
                setFormData({ ...formData, Name: e.target.value });
              } else {
                enqueueSnackbar("Special characters are not allowed in Relation.", { variant: "error" });
              }
            }}
            sx={{
              maxWidth: 250,
              "& .MuiOutlinedInput-root": {
                height: "28px",
                fontSize: "12px",
              },
              "& .MuiOutlinedInput-input": {
                padding: "4px 8px",
                fontSize: "12px",
              },
            }}
          />
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
          <Typography sx={{ width: 180, fontSize: "11px" }}>
            Description
          </Typography>
          <TextField
            size="small"
            fullWidth
            value={formData.Description}
            onChange={(e) =>
              setFormData({ ...formData, Description: e.target.value })
            }
            sx={{
              maxWidth: 250,
              "& .MuiOutlinedInput-root": {
                height: "28px",
                fontSize: "12px",
              },
              "& .MuiOutlinedInput-input": {
                padding: "4px 8px",
                fontSize: "12px",
              },
            }}
          />
        </Box>
      </Box>
    </CommonDialog>
  );
};

export default AddRelation;
